module.exports = __webpack_public_path__ + "assets/img/ru-87b5af06.png";